/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Widget Multi Balances Constants
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.10.0
 */

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/

export const WIDGET_MULTI_BALANCES_GET_LIST_START = '@@b2b_portal_ui/dashboard/widget/WIDGET_MULTI_BALANCES_GET_LIST_START';
export const WIDGET_MULTI_BALANCES_GET_LIST_SUCCESS = '@@b2b_portal_ui/dashboard/widget/WIDGET_MULTI_BALANCES_GET_LIST_SUCCESS';
export const WIDGET_MULTI_BALANCES_GET_LIST_FAILURE = '@@b2b_portal_ui/dashboard/widget/WIDGET_MULTI_BALANCES_GET_LIST_FAILURE';
